export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/transcode.worker.2f93d6b6.worker.js");
}
